import { required, requiredIf, numeric, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

/**
 * @param {object} formState
 * @param {Function} needsTaxInvoice getter — ใบซื้อนี้ต้องมีเลขที่/วันที่ใบกำกับของผู้ขายไหม
 *   (มี VAT + รับเข้าสาขาที่จด VAT) ดู silver-spoon-api/docs/vat-compliance.md ตัดสินใจ A1
 */
export default function (formState, needsTaxInvoice = () => false) {
  return {
    form: {
      transaction_date: {
        required: helpers.withMessage(i18n.global.t('Please enter a transaction date.'), required)
      },
      supplier_id: {
        required: helpers.withMessage(i18n.global.t('Please select supplier.'), required)
      },
      branch_id: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required)
      },
      tax_policy: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      ref_no: {
        required: helpers.withMessage(
          i18n.global.t('Please enter the tax invoice number.'),
          requiredIf(needsTaxInvoice)
        )
      },
      supplier_invoice_date: {
        required: helpers.withMessage(
          i18n.global.t('Please select the tax invoice date.'),
          requiredIf(needsTaxInvoice)
        )
      },
      quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric)
      },
      sub_total: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      discount_before_vat: {
      },
      discount_vat: {
      },
      discount: {
      },
      shipping_price_before_vat: {
      },
      shipping_price_vat: {
      },
      shipping_price: {
      },
      total_before_vat: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      total_vat: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      total: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      note: {},
      items: {
        required: helpers.withMessage(i18n.global.t('Please add at least one item.'), required)
      }
    }
  }
};
